import React, { useEffect, useState } from "react";
import { intl } from "LocaleWrapper";
import { useLazyQuery, useMutation } from "@apollo/client";

import { Table, Button, Checkbox } from "@cofano/cck";
import { Alert, Box } from "@mui/material";

import { CustomDialog } from "components/dialogs/Dialogs";

import { Language } from "imports/Utils";

import { DeleteRelationDocument } from "__generated__/view/relations/graphql/relation.mutations.generated";
import { GetRelationUsersDocument } from "__generated__/view/relations/graphql/relation.queries.generated";

const DeleteRelationDialog = ({ open, onClose, relationId, refetch }: {
	open: boolean;
	onClose: () => void;
	relationId: number;
	refetch: () => void;
}) => {

	const [ deactivateUsers, setDeactivateUsers ] = useState(false);
	const [ linkedUsers, setLinkedUsers ] = useState<{ id: number, username: string }[]>([]);

	const [ deleteRelation, { loading: deleteLoading } ] = useMutation(DeleteRelationDocument);
	const [ getRelation, { loading: getRelationLoading } ] = useLazyQuery(GetRelationUsersDocument);

	const loading = deleteLoading || getRelationLoading;

	const handleOnClose = () => {
		setDeactivateUsers(false);
		setLinkedUsers([]);
		onClose();
	};

	const onDelete = () => {
		deleteRelation({
			variables: {
				id: relationId,
				deleteLinkedUsers: deactivateUsers,
			},
		}).then(() => {
			handleOnClose();
			refetch();
		});
	};

	useEffect(() => {
		if (open) {
			getRelation({
				variables: {
					id: relationId,
				},
			}).then((response) => {
				setLinkedUsers(response.data?.relation?.users || []);
			});
		}
	}, [ open ]);

	return (
		<CustomDialog
			open={open}
			onClose={handleOnClose}
			title={intl.formatMessage({ id: "CONFIRM" })}
			actions={(
				<Button
					loading={loading}
					onClick={onDelete}
					color='danger'
					size="small">
					{Language("DELETE")}
				</Button>
			)}>
			<div>
				{linkedUsers.length > 0 ? (
					<React.Fragment>
						<Alert severity="warning">
							{Language("RELATION_LINKED_USERS")}
						</Alert>

						<Table
							id="relationLinkUsersTable"
							disableFooter={true}
							content={linkedUsers}
							contentLoading={loading}
							columns={[ {
								id: "username",
								title: intl.formatMessage({ id: "USER_USERNAME" }),
							} ]} />

						<Box mt={2}>
							<Checkbox
								checked={deactivateUsers}
								onChange={event => setDeactivateUsers(event.target.checked)}
								label={intl.formatMessage({ id: "DELETE_LINKED_USERS" })} />
						</Box>
					</React.Fragment>
				) : (
					<React.Fragment>
						{Language("CONFIRM_DELETE_DATA")}
					</React.Fragment>
				)}
			</div>
		</CustomDialog>
	);
};

export default DeleteRelationDialog;
